import React from 'react';
import PropTypes from 'prop-types';
import { withLocale } from '@dietlabs/components';
import { Redirect, withRouter } from 'react-router';
import Layout from 'Layout/Layout';
import Header from 'Layout/Header';
import { PATHS } from 'config/paths';
import {
    PATH_MEASUREMENT_INDEX,
    PATH_MEASUREMENT_EDIT,
} from 'Measurement/routes';
import Loader from 'Layout/Loader';
import MeasurementByDateForm from 'Measurement/MeasurementByDate/MeasurementByDateForm';
import MeasurementByDateFormPlaceholder from 'Measurement/MeasurementByDate/MeasurementByDateFormPlaceholder';
import { ApiDateType, SystemOfMeasuresType } from 'types/CommonTypes';
import PageContainerNarrow from 'Layout/Container/PageContainerNarrow';
import { callNativeAppRemoveLastRoute } from 'components/Helpers/callNativeAppRemoveLastRoute';

export class MeasurementEditContainer extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        date: ApiDateType,
        loading: PropTypes.bool.isRequired,
        saving: PropTypes.bool.isRequired,
        deleting: PropTypes.bool.isRequired,
        saveMeasurements: PropTypes.func.isRequired,
        deleteMeasurements: PropTypes.func.isRequired,
        measurements: PropTypes.shape({
            weight: PropTypes.number,
            hip: PropTypes.number,
            waist: PropTypes.number,
            thigh: PropTypes.number,
            chest: PropTypes.number,
            arm: PropTypes.number,
        }),
        systemOfMeasures: SystemOfMeasuresType,
        history: PropTypes.shape({
            location: PropTypes.shape({
                state: PropTypes.shape({
                    from: PropTypes.shape({
                        pathname: PropTypes.string,
                    }),
                }),
            }).isRequired,
        }).isRequired,
    };

    static defaultProps = {
        date: undefined,
        measurements: undefined,
        systemOfMeasures: undefined,
    };

    state = {
        redirectTo: null,
    };

    handleSave = async formData => {
        const { goalLost, goalReached } = await this.props.saveMeasurements({
            ...formData,
            systemOfMeasures: this.props.systemOfMeasures,
        });

        if (goalLost) {
            this.setState({ redirectTo: PATHS.GOAL_LOST });
        } else if (goalReached) {
            this.setState({ redirectTo: PATHS.GOAL_REACHED });
        } else if (
            this.props.history &&
            this.props.history.location &&
            this.props.history.location.state &&
            this.props.history.location.state.from
        ) {
            this.setState({
                redirectTo: {
                    pathname: this.props.history.location.state.from.pathname,
                },
            });
        } else {
            this.setState({ redirectTo: PATH_MEASUREMENT_INDEX });
        }
    };

    handleDateChange = date =>
        this.setState({
            // hack!!
            // unmount existed component and mount it again with new date
            // do not have to handle it in component
            redirectTo: {
                pathname: PATHS.REDIRECT_HELPER,
                state: {
                    redirectTo: PATH_MEASUREMENT_EDIT.split(':')[0] + date,
                },
            },
        });

    handleDelete = async date => {
        await this.props.deleteMeasurements(date);
        callNativeAppRemoveLastRoute('measure');
        callNativeAppRemoveLastRoute('measure');
        this.setState({ redirectTo: PATH_MEASUREMENT_INDEX });
    };

    render() {
        const {
            t,
            loading,
            saving,
            deleting,
            systemOfMeasures,
            date,
            measurements,
        } = this.props;

        const { redirectTo } = this.state;

        if (redirectTo) {
            return <Redirect to={redirectTo} />;
        }

        return (
            <Layout page="measurement">
                <Header>{t('measurments/add-measurments-button')}</Header>
                <PageContainerNarrow>
                    {loading ? (
                        <MeasurementByDateFormPlaceholder />
                    ) : (
                        <MeasurementByDateForm
                            systemOfMeasures={systemOfMeasures}
                            date={date}
                            weight={measurements.weight}
                            hip={measurements.hip}
                            waist={measurements.waist}
                            thigh={measurements.thigh}
                            chest={measurements.chest}
                            arm={measurements.arm}
                            onDateChange={this.handleDateChange}
                            onSave={this.handleSave}
                            onDelete={this.handleDelete}
                        />
                    )}
                    {saving || deleting ? <Loader /> : ''}
                </PageContainerNarrow>
            </Layout>
        );
    }
}

export default withRouter(withLocale(MeasurementEditContainer));
